export { default } from './Divider';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/Divider/index.js
// module id = 584
// module chunks = 121